import React from 'react'
import {
  BsRocket,
  BsStars,
  BsBuilding,
  BsCpu
} from 'react-icons/bs'
import { MdChevronRight } from 'react-icons/md'
import { TbCircle, TbDiamond, TbHexagon, TbSquare, TbTriangle } from 'react-icons/tb'

export default function PlanPricing() {
  return (
    <div className='container'>
      <h3 className='text-center text-muted'>هوشمندسازی سازمانی</h3>
      <br />
      <div className='row justify-content-center'>

        {/* طرح پایه */}
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>

              <div>
                <span className='text-primary'>
                  <TbCircle size={'35px'} />
                </span>
              </div>

              <br />

              <h5 className='bold text-primary'>طرح اول</h5>

              <br />

              <p className='brand-p bold'>
                مناسب برای کسب و کارهای کوچک و شروع استفاده از خدمات هوشمند
              </p>

              <hr />

              <div className='text-muted bold'>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>توسعه و استقرار</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پشتیبانی</p>
                  <p className='bold text-primary'>سازمانی</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>کاربر</p>
                  <p>5</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>حافظه</p>
                  <p>25 GB</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p className='bold'>مبلغ</p>
                  <p className='bold'>۲۵ میلیون تومان</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center text-primary'>
                  <p className='bold'>اعتبار نهایی حساب کاربری</p>
                  <p className='bold'>۳۰ میلیون تومان</p>
                </div>

              </div>
            </div>

            <br />
          </div>
        </div>

        {/* طرح حرفه ای */}
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>

              <div>
                <span className='text-primary'>
                  <TbSquare size={'35px'} />
                </span>
              </div>

              <br />

              <h5 className='bold text-primary'>طرح دوم</h5>

              <br />

              <p className='brand-p bold'>
                مناسب برای کسب و کارهای در حال رشد با نیاز به امکانات و ظرفیت بیشتر
              </p>

              <hr />

              <div className='text-muted bold'>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>توسعه و استقرار</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پشتیبانی</p>
                  <p className='bold text-primary'>سازمانی</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>کاربر</p>
                  <p>نامحدود</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>حافظه</p>
                  <p>1 TB</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p className='bold'>مبلغ</p>
                  <p className='bold'>۵۰ میلیون تومان</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center text-primary'>
                  <p className='bold'>اعتبار نهایی حساب کاربری</p>
                  <p className='bold'>۶۰ میلیون تومان</p>
                </div>

              </div>
            </div>

            <br />
          </div>
        </div>

        {/* طرح پیشرفته */}
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>

              <div>
                <span className='text-primary'>
                  <TbDiamond size={'35px'} />
                </span>
              </div>

              <br />

              <h5 className='bold text-primary'>طرح سوم</h5>

              <br />

              <p className='brand-p bold'>
                مناسب برای سازمان هایی که به امکانات پیشرفته و پردازش گسترده نیاز دارند
              </p>

              <hr />

              <div className='text-muted bold'>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>توسعه و استقرار</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پشتیبانی</p>
                  <p className='bold text-primary'>سازمانی</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>کاربر</p>
                  <p>نامحدود</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>حافظه</p>
                  <p>نامحدود</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p className='bold'>مبلغ</p>
                  <p className='bold'>۱۰۰ میلیون تومان</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center text-primary'>
                  <p className='bold'>اعتبار نهایی حساب کاربری</p>
                  <p className='bold'>۱۲۰ میلیون تومان</p>
                </div>

              </div>
            </div>

            <br />
          </div>
        </div>

        {/* طرح سازمانی */}
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>

              <div>
                <span className='text-primary'>
                  <TbHexagon size={'35px'} />
                </span>
              </div>

              <br />

              <h5 className='bold text-primary'>طرح ویژه</h5>

              <br />

              <p className='brand-p bold'>
                راهکاری جامع و اختصاصی برای سازمان های بزرگ با نیازهای پیچیده و مقیاس بالا
              </p>

              <hr />

              <div className='text-muted bold'>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>توسعه و استقرار</p>
                  <p>قراردادی</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پشتیبانی</p>
                  <p className='bold'>قراردادی</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>کاربر</p>
                  <p>قراردادی</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>حافظه</p>
                  <p>قراردادی</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>مبلغ</p>
                  <p className='bold'>قراردادی</p>
                </div>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>اعتبار نهایی حساب کاربری</p>
                  <p className='bold'>قراردادی</p>
                </div>

              </div>
            </div>

            <br />
          </div>
        </div>

      </div>

      <div className='d-flex flex-row justify-content-end'>
        <p className='text-muted'>
          به مبالغ و اعتبارات فوق ۱۰ درصد  بر پایه مالیات بر ارزش افزوده اضافه می گردد
          <span className='m-2'>
            <MdChevronRight />
          </span>
        </p>
      </div>

    </div>
  )
}